import ResourceManager from '@/Management/ResourceManager';
import ComponentManager from '@/Management/ComponentManager';

import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';
import ImageViewModel from '@/ViewModels/Controls/ImageViewModel';
import ButtonViewModel from '@/ViewModels/Controls/ButtonViewModel';
import WindowViewModel from '@/ViewModels/Controls/WindowViewModel';
import MessageBoxViewModel from '@/ViewModels/Controls/MessageBoxViewModel';
import GlobalConfiguration from '@/Management/GlobalConfiguration';

const locator = 'notice-message';
const windowLocator = 'window';
const imageLocator = 'content.image';
const labelLocator = 'content.label';

const imageSource = 'message_warning.png';
const yes = 'YES';
const no = 'NO';

export default class ReplaceFilterMessageBoxViewModel extends MessageBoxViewModel {
    public constructor(yesCallback: Function) {

        let label = new LabelViewModel({
            parentLocator: locator,
            locator: labelLocator,
            ergName: 'REPLACE_FILTER_MESSAGEBOX'
        });

        let yesButton = new ButtonViewModel({
            label: new LabelViewModel({
                ergName: 'YES',
                parentLocator: locator,
                locator: 'yes.label'
            }),
            image: new ImageViewModel({
                parentLocator: locator,
                locator: 'yes.image',
                source: GlobalConfiguration.inlineImages.WINDOW_OK,
                alternativeText: new LabelViewModel({
                    ergName: 'YES'
                })
            }),
            onClick: () => {
                this.window.isOpen(false);
                yesCallback();
            },
            parentLocator: locator,
            locator: 'yes'
        });

        let noButton = new ButtonViewModel({
            label: new LabelViewModel({
                ergName: 'NO',
                parentLocator: locator,
                locator: 'no.label'
            }),
            image: new ImageViewModel({
                parentLocator: locator,
                locator: 'no.image',
                source: GlobalConfiguration.inlineImages.WINDOW_CANCEL,
                alternativeText: new LabelViewModel({
                    ergName: 'NO'
                })
            }),
            onClick: () => {
                this.window.isOpen(false);
            },
            parentLocator: locator,
            locator: 'no'
        });

        let image = new ImageViewModel({
            parentLocator: locator,
            locator: imageLocator,
            source: imageSource
        });

        let window = new WindowViewModel({
            parentLocator: locator,
            locator: windowLocator,
            width: 620,
            isModal: true,
            isOpen: true,
            allowClose: true,
            headline: new LabelViewModel({
                ergName: 'REPLACE_FILTER_MESSAGEBOX_TITLE'
            })
        });

        super({
            window: window,
            image: image,
            label: label,
            buttons: [yesButton, noButton]
        });
    }
}

ComponentManager.setViewModel('ReplaceFilterMessageBoxViewModel', ReplaceFilterMessageBoxViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');